(function () {
  var scriptUrl = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';

  function openPreferences() {
    privacyBanner.showPreferences().catch(function (error) { console.error('Cookie preferences failed', error); });
  }

  function handleClick() {
    if (typeof privacyBanner !== 'undefined') {
      openPreferences();
      return;
    }

    var existingScript = document.querySelector('script[data-heritage-privacy-banner]');
    if (existingScript) {
      existingScript.addEventListener('load', openPreferences, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.dataset.heritagePrivacyBanner = 'true';
    script.addEventListener('load', openPreferences, { once: true });
    document.head.appendChild(script);
  }

  function bindButtons() {
    document.querySelectorAll('[data-cookie-preferences]').forEach(function (button) {
      if (button.dataset.cookiePreferencesBound === 'true') return;
      button.dataset.cookiePreferencesBound = 'true';
      button.addEventListener('click', handleClick);
    });
  }

  bindButtons();
  document.addEventListener('DOMContentLoaded', bindButtons, { once: true });
  new MutationObserver(bindButtons).observe(document.documentElement, { childList: true, subtree: true });
})();
